import { Skeleton } from '@/new/components/shadcn/skeleton';

export function FactsTableLoader() {
  return (
    <div className="flex h-full w-full flex-col gap-2 pt-1 pb-6">
      {Array.from({ length: 12 }).map((_, index) => (
        <div key={index} className="flex w-full items-center gap-2.5">
          <Skeleton className="h-5 w-5 rounded-full" />
          <div className="w-full rounded-md border">
            <div className="p-2.5">
              <div className="flex w-full justify-between">
                <Skeleton className="h-3 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
              <div className="mt-1 flex items-center justify-between">
                <Skeleton className="h-3 w-5/6" />
                <Skeleton className="h-3 w-12" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
